import {useDeleteCategoryMutation} from "hooks/queries/category.query"
import {MouseEventHandler} from "react"

type Props = {
    id: number
}
export default function CategoryItemDeleteButton({id}: Props) {
    const deleteCategory = useDeleteCategoryMutation()

    const onClick: MouseEventHandler = (e) => {
        e.preventDefault()
        e.stopPropagation()
        if (window.confirm('정말 삭제하시겠습니까?')) {
            deleteCategory.mutate(id)
        }
    }
    return (
        <button className="ml-1 button is-small is-rounded is-danger is-outlined" onClick={onClick}>삭제</button>
    )
}